// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__2QMZ4","row":"Node_row__2_OJ0","label":"Node_label__8Vg3w","footer":"Node_footer__xSdhu"};